import React from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from 'reactstrap';

const ToolTip = (props) => {
    return (
        <>
            <Link to={props.to} onClick={props.onClick} className="text-dark"><i className={props.faName} id={props.linkId} aria-hidden="true"></i></Link>
            <UncontrolledTooltip placement={props.placement} target={props.linkId}>
                {props.title}
            </UncontrolledTooltip>
        </>
    )
}

export default ToolTip;